import { faDesktop, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useRef } from 'react';
import { toast } from 'react-hot-toast';
import { trackEvent } from '@services/tracking';
import { useCopyToClipboard } from '@client/new/shared/useCopyToClipboard';
import { useWindowSize } from '@client/new/shared/useWindowSize';
import { useSessionStorage } from '@client/new/shared/useSessionStorage';

const MOBILE_DESKTOP_BANNER_DISMISSED = 'mobile-desktop-banner-dismissed';
const DESKTOP_BREAKPOINT_PX = 768;

export const DesktopSwitchBanner = () => {
  const { width } = useWindowSize();
  const [dismissed, setDismissed] = useSessionStorage<boolean>(
    MOBILE_DESKTOP_BANNER_DISMISSED,
    false,
  );
  const [, copyToClipboard] = useCopyToClipboard();
  const trackedShownRef = useRef(false);

  const isVisible =
    width !== null && width < DESKTOP_BREAKPOINT_PX && !dismissed;

  useEffect(() => {
    if (!isVisible || width === null || trackedShownRef.current) return;
    trackEvent({
      type: 'Mobile Desktop Banner Shown',
      payload: {
        'Viewport Width': width,
        Path: window.location.pathname,
      },
    });
    trackedShownRef.current = true;
  }, [isVisible, width]);

  if (!isVisible || width === null) {
    return null;
  }

  const handleCopy = () => {
    copyToClipboard(window.location.href);
    toast.success('Link copied');
    trackEvent({
      type: 'Mobile Desktop Banner Action',
      payload: {
        'Viewport Width': width,
        Path: window.location.pathname,
        Action: 'copy_link',
      },
    });
  };

  const handleDismiss = () => {
    setDismissed(true);
    trackEvent({
      type: 'Mobile Desktop Banner Action',
      payload: {
        'Viewport Width': width,
        Path: window.location.pathname,
        Action: 'dismiss',
      },
    });
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[1200]">
      <div className="flex items-center justify-between gap-4 rounded-t-[10px] bg-black/[0.84] px-6 py-9 text-white">
        <div className="flex items-center gap-4 text-sm leading-5">
          <FontAwesomeIcon icon={faDesktop} className="shrink-0" />
          <span>Switch to desktop for the full experience</span>
        </div>
        <div className="flex shrink-0 items-center gap-4">
          <button
            type="button"
            onClick={handleCopy}
            className="text-sm font-medium leading-5 underline"
          >
            Copy link
          </button>
          <button
            type="button"
            onClick={handleDismiss}
            aria-label="Dismiss"
            className="flex items-center justify-center"
          >
            <FontAwesomeIcon icon={faXmark} className="text-xl" />
          </button>
        </div>
      </div>
    </div>
  );
};
